module.exports = __webpack_public_path__ + "assets/images/walk_support_y.c4d52ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/walk_support_y.png
// module id = 776
// module chunks = 1